<template>
  <div class="mainDiv">
    <div class="outerDiv"></div>
    <div class="innerDiv">
      <div class="textClass">{{ title }}</div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="svgClass">
      <defs v-if="gradient">
        <linearGradient id="gradient">
          <stop offset="0%" stop-color="#e91e63" />
          <stop offset="100%" stop-color="#673ab7" />
        </linearGradient>
      </defs>
      <circle
        v-if="!gradient"
        cx="100"
        cy="100"
        r="73"
        :stroke-dashoffset="dash"
        :stroke="color"
        stroke-linecap="round"
      />
      <circle
        v-if="gradient"
        cx="110"
        cy="110"
        r="75"
        :stroke-dashoffset="dash"
        stroke="url(#gradient)"
        fill="none"
        stroke-linecap="round"
      />
   </svg>
  </div>
  </template>

  <script>
  export default {
    name: 'SProgress',
    data(){
      return{
        dash: 0,
      }
    },
    props: {
      progress: {
        required: true,
      },
      color: {
        default: "var(--primary)",
      },
      gradient: {
        default: false,
      },
      title: {},
    },

    watch: {
      progress(n){
          this.dash = 440.056 - (440.056 * n ) / 100
      }
    }
  }
  </script>

  <style lang="scss" scoped>
  .mainDiv{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
  }
  .outerDiv{
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
  }
  .innerDiv{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 160px;
    border-radius: 50%;
    border: solid 18px #e0e0e0;
  }
  .textClass{  font-size: 0.9rem; }
  .svgClass{
    position: absolute;
    top:0;
    left:0;
    width: 200px;
    height: 200px;
  }
  circle{
    fill: none;
    stroke-width: 18px;
    stroke-dasharray: 440.056;
    // stroke-dashoffset : 440.056;
  }


  </style>